import React, {useContext, useEffect, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import {getCurrentPrompts} from "../aiApi";
import UiPopupAIContentFeatureGroups from "./UiPopupAIContentFeatureGroups";
import UiPopupAIContentPrompts from "./UiPopupAIContentPrompts";
import UiPopupAIContentMainPrompt from "./UiPopupAIContentMainPrompt";
import UiPopupAIContentResult from "./UiPopupAIContentResult";
import LoadingSpinner from "../../ui/loadingSpinner";
import {getAIInitialGroups} from "../aiFunctions";
import UiPopupAIContentDropdowns from "./UiPopupAIContentDropdowns";
import UiPopupAIContentToggleAllGroupsCheckbox from "./UiPopupAIContentToggleAllGroupsCheckbox";
import {getCurrentLayout} from "../../appLayout";
import {getAIGlobalSettings} from "../aiAsyncActions";
import UiPopupAIContentFeaturesAreas from "./UiPopupAIContentFeaturesAreas";


const UiPopupAIContent = (props) => {

  const {aiLoading, aiImportData, aiSettings, getAIGlobalSettings} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {userFile} = uiPopupContext;

  const [loading, setLoading] = useState(true);

  const checkIfButtonDisabled = () => {
    uiPopupDispatch({
      saveButtonDisabled: aiLoading ? false : !userFile, // unblock save button if file is uploaded from look ai, to stop it
    });
  }

  const setInitialAiLogic = async () => {
    setLoading(true);
    // `loading` starts as true, so anything throwing before setLoading(false) used to leave
    // the whole popup on the spinner with no content and no visible error - most commonly
    // getCurrentPrompts() when :7122/api/Prompt is unreachable.
    let aiResponses = [];
    try {
      aiResponses = await Promise.all([
        getCurrentPrompts(),
        getAIGlobalSettings()
      ]);
    } catch (e) {
      console.log("setInitialAiLogic: failed to load AI prompts / global settings", e);
    }
    setLoading(false);
    const newGroupObjects = getAIInitialGroups(aiImportData, aiSettings, true)
    const layout = getCurrentLayout();
    const allFeatureGroups = layout.getAllFeatureGroups();

    uiPopupDispatch({
      userFile: null,
      promptsList: aiResponses[0],
      saveButtonDisabled: true,
      groupObjects: newGroupObjects,
      showAllFeatureGroups: false,
      allFeatureGroups,
    });
    checkIfButtonDisabled();
  }

  useEffect(() => {
    setInitialAiLogic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkIfButtonDisabled()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aiLoading]);

  const onFileChange = (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    uiPopupDispatch({
      userFile: event.target.files[0],
      saveButtonDisabled: false,
    });
  }

  return (
    <div className="u-h-full u-w-full u-pl-075 u-pr-075 scrollable relative">
      {loading ? <LoadingSpinner size="smaller"/> : (
        <div>
          <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">01. Upload File</div>
          <div className="flex flex--start u-mb-1">
            <label className="border border-dashed link link--blue border-primary u-p-05 rounded hover:bg-lightgray3" htmlFor="aiFileUpload">Upload File {userFile ?
              <span className={"u-pl-1 u-h-1 u-leading-1 color-active bold"}>{userFile.name}</span> : null}
            </label>
            <input type="file" id="aiFileUpload" accept="image/*" className="display-none" onChange={onFileChange}/>
          </div>
          <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">02. Select Render Options</div>
          <UiPopupAIContentDropdowns/>
          <UiPopupAIContentFeaturesAreas/>
          <div className="product-actions__title u-mb-1 u-mt-0 flex flex--center flex--between">
            <span className="flex-1 text-left bold scart-block__list-item-text-title">03. Select First Prompt</span>
            <UiPopupAIContentToggleAllGroupsCheckbox/>
          </div>
          <div className="flex flex--center flex--between u-mb-1" style={{height: "200px"}}>
            <div className="u-pr-05 u-h-full" style={{width: "220px"}}>
              <UiPopupAIContentPrompts type={"First"}/>
            </div>
            <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full">
              <UiPopupAIContentMainPrompt type={"First"}/>
            </div>
            <div className="u-pl-05 u-pr-05 u-h-full flex--1">
              <UiPopupAIContentFeatureGroups type={"First"}/>
            </div>
          </div>
          <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">04. Select Second Prompt</div>
          <div className="flex flex--center flex--between u-mb-1" style={{height: "200px"}}>
            <div className="u-pr-05 u-h-full" style={{width: "220px"}}>
              <UiPopupAIContentPrompts type={"Second"}/>
            </div>
            <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full">
              <UiPopupAIContentMainPrompt type={"Second"}/>
            </div>
            <div className="u-pl-05 u-pr-05 u-h-full flex--1">
              <UiPopupAIContentFeatureGroups type={"Second"}/>
            </div>
          </div>
          <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">05. Select Third Prompt</div>
          <div className="flex flex--center flex--between u-mb-1" style={{height: "200px"}}>
            <div className="u-pr-05 flex flex--center flex--column u-h-full" style={{width: "220px"}}>
              <UiPopupAIContentPrompts type={"Third"}/>
            </div>
            <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full">
              <UiPopupAIContentMainPrompt type={"Third"}/>
            </div>
            <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full" style={{height: "200px"}}>
              <UiPopupAIContentFeatureGroups type={"Third"}/>
            </div>
          </div>
          <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">06. Get Render Result</div>
          <UiPopupAIContentResult/>
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  const {aiLoading, aiImportData} = store.aiState;
  const {aiSettings} = store.fabricatorState;

  return {
    fabricatorData,
    aiLoading,
    aiSettings,
    aiImportData,
  };
};

const mapDispatchToProps = {
  getAIGlobalSettings,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UiPopupAIContent)
)
